import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useData } from "../context/DataContext";
import { useSettings } from "../context/SettingsContext";
import { DAYS_OF_WEEK } from "../lib/types";
import StudentForm from "../components/StudentForm";

export default function EditStudent() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { getAnyStudent, updateStudent } = useData();
    const { settings } = useSettings();

    const student = getAnyStudent(id);

    const availableDays = DAYS_OF_WEEK.filter((d) =>
        settings.workingDays.includes(d),
    );

    if (!student) {
        return (
            <div className="text-center py-20" data-testid="edit-student-not-found">
                <div className="font-display font-bold text-3xl uppercase mb-3">
                    Student not found
                </div>
                <Link to="/students" className="text-[#3D6385] font-bold">
                    Back to students
                </Link>
            </div>
        );
    }

    const handleSubmit = (payload) => {
        const saved = updateStudent(id, payload);
        if (!saved) return;
        toast.success(`${saved.name} updated`);
        navigate(`/students/${id}`);
    };

    return (
        <div className="max-w-3xl mx-auto space-y-6" data-testid="edit-student-page">
            <Link
                to={`/students/${id}`}
                className="inline-flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-slate-800"
                data-testid="edit-back-link"
            >
                <ArrowLeft size={16} strokeWidth={2.8} />
                Back to {student.name}
            </Link>
            <div>
                <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 mb-1">
                    Editing
                </div>
                <h1 className="font-display font-bold text-4xl sm:text-5xl uppercase tracking-tight">
                    {student.name}
                </h1>
            </div>

            <StudentForm
                initial={student}
                availableDays={availableDays}
                submitLabel="Save Changes"
                cancelTo={`/students/${id}`}
                onSubmit={handleSubmit}
                testIdPrefix="edit-"
            />
        </div>
    );
}
